import { Controller } from '@hotwired/stimulus';

/**
 * discussion-autoscroll — keeps a discussion message list scrolled to the
 * newest message, like a chat app. Mounted on the scrolling message list
 * container (any overflow-y-auto message list zone), used by both the
 * planning phase panel and any other discussion thread surface.
 *
 *   • connect(): scroll to the bottom so the latest message is visible when
 *     the panel opens. Deferred to the next frame because the slide-over may
 *     still be sizing in (it can mount at height 0).
 *   • a MutationObserver on the list's direct children re-scrolls to the
 *     bottom whenever a message is appended — a Turbo Stream `append` into
 *     this list leaves the element (and this controller) connected.
 *
 * No targets/values — it operates on its own element. The global listener
 * (MutationObserver) is torn down in disconnect() per the connect/disconnect
 * symmetry rule.
 */
export default class extends Controller {
  connect() {
    this.scrollToBottom();
    this.observer = new MutationObserver(() => this.scrollToBottom());
    this.observer.observe(this.element, { childList: true });
  }

  disconnect() {
    this.observer?.disconnect();
    this.observer = null;
  }

  scrollToBottom() {
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight;
    });
  }
}
